import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Header, Card, Image } from 'semantic-ui-react';
import i18next from 'i18next';

import './MarketingTool.scss';

const MarketingTool = (props) => {
    

    const renderOption = ({ image, header, description, linkTo }) => {
        return (
            <Card className="option-card" as={Link} to={linkTo}>
                <Image src={image} wrapped ui={false} size='large' />
                <Card.Content>
                    <Card.Header>{header}</Card.Header>
                </Card.Content>
                <Card.Content extra>
                    <Card.Meta>{description}</Card.Meta>
                </Card.Content>
            </Card>
        );
    };

    return (
        <div className="pi-marketing-tool">
            <Header.Content>{i18next.t('marketingToolPage.welcome')}</Header.Content>
            <Card.Group centered>
                {renderOption({
                    image: 'https://s3-eu-west-1.amazonaws.com/assets.paidit.common-bucket/BrandBuilder.png',
                    header: i18next.t('navBrandsTitle'),
                    description: i18next.t('navBrandsDescription'),
                    linkTo: 'marketing/brands'
                })}
                {renderOption({
                    image: 'https://s3-eu-west-1.amazonaws.com/assets.paidit.common-bucket/SmartPromotions.png',
                    header: i18next.t('navSmartPromotionsTitle'),
                    description: i18next.t('navSmartPromotionsDescription'),
                    linkTo: 'marketing/smartPromotions'
                })}
                {renderOption({
                    image: 'https://s3-eu-west-1.amazonaws.com/assets.paidit.common-bucket/CampaignsManagement.png',
                    header: i18next.t('navCampaignsManagementTitle'),
                    description: i18next.t('navCampaignsManagementDescription'),
                    linkTo: 'marketing/campaigns'
                })}
            </Card.Group>
        </div>
    );
};

MarketingTool.propTypes = {
    editedDashboardUser: PropTypes.object,
    setDashboardUserForEdit: PropTypes.func,
    
    image: PropTypes.string,
    header: PropTypes.string,
    description: PropTypes.string,
    linkTo: PropTypes.string
};

export default MarketingTool;
